import React, { useEffect, useState } from 'react';
import bgImage from "../../assets/images/bg-sign-up-cover.jpeg";
import MDTypography from '../controls/MDTypography';
import BasicLayout from '../layauots/BasicLayout';
import { Card } from 'react-bootstrap';
import MDBox from '../controls/MDBox';
import MDInput from '../controls/MDInput';
import MDButton from '../controls/MDButton';
import { Alert, AlertTitle } from '@mui/material';
import { KeyFill } from 'react-bootstrap-icons';
import { Link, useNavigate } from "react-router-dom";
import { postData } from '../Utils/Http/api';
import { useSearchParams } from "react-router-dom";
function ConfirmarCuentaxToken() {
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);
  const [grabando, setGrabando] = useState(false);
  const [showprogrees, setShowprogrees] = useState(0);
  const [searchParams] = useSearchParams();
  const [alertSeverity, setAlertSeverity] = useState("success");
  useEffect(() => {
    localStorage.removeItem("isRegister");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("isActivarCuenta");
    localStorage.removeItem("isForgotPassword");
    localStorage.setItem("isActivarCuenta", "true");
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    if (email && token) {
      setFormData({
        email: decodeURIComponent(email),
        emailconfirmadotoken: token,
      });
    }
  }, [useSearchParams]);

  const [formData, setFormData] = useState({
    // Inicializa los campos del formulario
    email: "",
    emailconfirmadotoken: ""
    // ... otros campos
  });

  const handleInputChange = (event) => {
    // Maneja los cambios en los campos del formulario
    setGrabando(false);
    setShowprogrees(1);
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleConfirmado = () => {
    localStorage.setItem('isRegister', 'false');
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.setItem('isActivarCuenta', 'false');
    localStorage.setItem('isForgotPassword', 'false');
  };
  const handleSubmit = async () => {
    setGrabando(true);
    setExito(false);
    setMensaje('');

    try {
      const response = await postData("/UsuarioConfirmarCuentaxToken", formData);

      if (response.isSuccess) {
        setExito(true);
        setMensaje("🎊 ¡Listo! Tu usuario está activo. ¡Disfruta de la experiencia en el sistema!");
        setAlertSeverity("success");
        setGrabando(true);
      } else {
        setExito(false);
         setGrabando(false);
        setMensaje(response.error || "No se pudo activar la cuenta.");
        setAlertSeverity("warning");
      }
    } catch (error) {
      setExito(false);
       setGrabando(false);
      setMensaje(error.message || "Ocurrió un error al activar la cuenta.");
      setFormData({
        ...formData,
        emailconfirmadotoken: ""
      });
      setAlertSeverity("info");
    } 
  };
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="warning"
          borderRadius="lg"
          coloredShadow="warning"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            ¡Bienvenido a la Activacion de su cuenta Data Muni!
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Completa los datos solicitados con el mail que te registraste mas el Token de seguridad que recibiste por correo
          </MDTypography>

        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">

            <MDBox mb={2}>
              <MDInput
                type="email"
                name="email"
                label="Email"
                required
                variant="standard"
                value={formData.email}
                onChange={handleInputChange}

                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="emailconfirmadotoken"
                label="Token"
                required
                variant="standard"
                value={formData.emailconfirmadotoken}
                onChange={handleInputChange}

                fullWidth
              />
            </MDBox>
          </MDBox>

        </MDBox>
        <MDBox height="150px" textAlign="center">
          <MDButton variant="gradient" color="warning" onClick={() => {
            handleSubmit();

          }} disabled={grabando} endIcon={<KeyFill />}>
            Activar Cuenta
          </MDButton>
        </MDBox>
        <MDBox mt={4} mb={1} textAlign="center">
          <MDTypography variant="button" color="text">
            Ya activaste tu cuenta?{" "}
            <MDTypography
              component={Link}
              to="/Login"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
              onClick={() => {
                handleConfirmado();
              }}
            >
              Ir al Inicio
            </MDTypography>
          </MDTypography>
        </MDBox>
        {mensaje !== "" && (
          <Alert severity={alertSeverity}>
            <AlertTitle>{exito ? "Felicitaciones" : alertSeverity === "warning" ? "Advertencia" : "Info"}</AlertTitle>
            {mensaje}
          </Alert>
        )}
      </Card>
    </BasicLayout >
  );
}
export default ConfirmarCuentaxToken;
